export default __webpack_public_path__ + "static/media/Human8.c5ba78cf.png";